import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Providers } from './providers'
import './styles/globals.css'
import '@/lib/api' // configure SDK client: baseUrl, auth interceptor, 401 refresh

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

/**
 * Enable Mock Service Worker in development
 * เปิดใช้งาน Mock Service Worker ในโหมดพัฒนา
 */
async function enableMocking() {
  // Check if mock mode is enabled via env or localStorage
  const isMockEnabled =
    import.meta.env['VITE_ENABLE_MSW'] === 'true' || localStorage.getItem('enable-msw') === 'true'

  if (!isMockEnabled) {
    return
  }

  const { worker } = await import('./mocks/browser')

  // Start the worker with onUnhandledRequest config
  return worker.start({
    onUnhandledRequest: 'warn', // Warn about unhandled requests
  })
}

enableMocking()
  .then(() => {
    createRoot(rootElement).render(
      <StrictMode>
        <Providers>
          <RouterProvider router={router} />
        </Providers>
      </StrictMode>
    )
  })
  .catch((error: unknown) => {
    console.error('Failed to start MSW:', error)
    // Render app even if MSW fails
    createRoot(rootElement).render(
      <StrictMode>
        <Providers>
          <RouterProvider router={router} />
        </Providers>
      </StrictMode>
    )
  })
